import React from 'react';
import BuilderMaskGroup from '../mask/group';
import BuilderBooleanProperty from '../properties/boolean';
import BuilderNameProperty from '../properties/name';
import { i18n } from '@form-engine/builder-application';
import FormEngine from '@form-engine/core-application/index';
import { ElementDefinition } from '@form-engine/core-application/types/form';
import { useMaskContext } from '../../hooks/use-mask';

export default function BuilderMaskGroupGeneral({
    name,
    hidden,
    disabled,
}: {
    name?: boolean;
    hidden?: boolean;
    disabled?: boolean;
}) {
    const { state } = useMaskContext<ElementDefinition>();
    const isField = state?.type && state?.type in FormEngine.getFieldElements();

    return (
        <BuilderMaskGroup id="BuilderMaskGroupGeneral">
            {name !== false && <BuilderNameProperty />}
            {hidden !== false && (
                <BuilderBooleanProperty
                    propertyName="hidden"
                    label={i18n.c('mask.generalGroup.hidden')}
                />
            )}
            {(isField || disabled === true) && (
                <BuilderBooleanProperty
                    propertyName="disabled"
                    label={i18n.c('mask.generalGroup.disabled')}
                />
            )}
        </BuilderMaskGroup>
    );
}
